<template>
  <svg preserveAspectRatio="xMidYMax slice" viewBox="0 0 1920 1080" id="canvas"></svg>
</template>

<script>
import api from './api.js'
import auth from './auth.js'
import formatter from './formatter.mixin.js';

export default {
  name: 'groups-map',
  props: [
    'template',
    'groups'
  ],
  mixins: [formatter],
  watch: {
    groups: function(newVal, oldVal) {
      this.drawGroups(this.template, this.groups);
    }
  },
  mounted() {
    this.drawGroups(this.template, this.groups);
  },
  beforeDestroy() {
  },
  methods: {
    drawGroups(template, groups) {
      var canvas = this.$svg.get('#canvas'); //.size('100%','100%');

      canvas.clear();
      canvas.svg(template);

      function getD(radius, startAngle, endAngle) {
        const isCircle = endAngle - startAngle === 360;
        if (isCircle) {
          endAngle--;
        }
        const start = polarToCartesian(radius, startAngle);
        const end = polarToCartesian(radius, endAngle);
        const largeArcFlag = endAngle - startAngle <= 180 ? 0 : 1;
        const d = [
          "M", start.x, start.y,
          "A", radius, radius, 0, largeArcFlag, 1, end.x, end.y];
        if (isCircle) {
          d.push("Z");
        } else {
          d.push("L", radius, radius,
            "L", start.x, start.y,
            "Z");
        }
        return d.join(" ");
      }

      function round(n) {
        return Math.round(n * 10) / 10;
      }

      function polarToCartesian(radius, angleInDegrees) {
        var radians = (angleInDegrees - 90) * Math.PI / 180;
        return {
          x: round(radius + (radius * Math.cos(radians))),
          y: round(radius + (radius * Math.sin(radians)))
        };
      }

      function pie(radius, ...vals) {
        const total = vals.reduce((a, b) => a + b, 0);
        const data = vals.map(val => ({ val, degrees: val / total * 360 }));
        data.forEach((o, i, ar) => {
          if (!i) {
            o.from = 0;
            o.to = o.degrees;
          } else {
            o.from = ar[i - 1].to;
            o.to = o.from + o.degrees;
          }
          o.path = path(getD(radius, o.from, o.to), i);
        });
        //return data.map(o => o.path).join('');
        return svg(radius * 2, data.map(o => o.path).join(''));
      }

      function svg(width, content) {
        return `<g class="pie">${content}</g>`;
      }

      function path(d, idx) {
        var cl = "operational-online";
        switch(idx) {
          case 0:
            cl = "inspection-online";
            break;
          case 1:
            cl = "maintenance-online";
            break;
          case 2:
            cl = "inspection-offline-2h";
            break;
          case 3:
            cl = "maintenance-offline-2h";
            break;
          case 4:
            cl = "inspection-offline-24h";
            break;
          case 5:
            cl = "maintenance-offline-24h";
            break;
          case 6:
            cl = "repair";
            break;
          case 7:
            cl = "unknown";
            break;
          case 8:
            cl = "operational-online";
            break;
          case 9:
            cl = "operational-offline-2h";
            break;
          case 10:
            cl = "operational-offline-24h";
            break;
          case 11:
            cl = "shutdown";
            break;
          case 12:
            cl = "error";
            break;
          case 13:
            cl = "fire";
            break;
          case 14:
            cl = "alarm";
            break;
          case 15:
            cl = "evac";
            break;
          case 16:
            cl = "poweroff";
            break;
        }
        return `<path d='${d}' class='${cl}'/>`;
      }

      for(var i = 0; i < groups.length; i++) {
        var group = groups[i];
        var groupLink = '/#/groups/' + group.id;

        var id = '#' + group.map_id + '-hide';
        var groupHideElement = this.$svg.get(id);
        if(groupHideElement != null) {
          if(group.elevators.length == 0) {
            //groupHideElement.node.style.display = 'none';
            groupHideElement.attr('opacity', 0.25);
          } else {
            groupHideElement.linkTo(groupLink);
          }
        }

        var groupPie = this.$svg.get('#' + group.map_id + '-pie');
        if(groupPie != null) {
          var amountInspectionOnline = group.elevators.filter(e => e.status == -7).length
          var amountMaintenanceOnline = group.elevators.filter(e => e.status == -6).length
          var amountInspectionOffline2h = group.elevators.filter(e => e.status == -5).length
          var amountMaintenanceOffline2h = group.elevators.filter(e => e.status == -4).length
          var amountInspectionOffline24h = group.elevators.filter(e => e.status == -3).length
          var amountMaintenanceOffline24h = group.elevators.filter(e => e.status == -2).length
          var amountRepair = group.elevators.filter(e => e.status == -1).length
          var amountUnknown = group.elevators.filter(e => e.status == 0).length
          var amountNormal = group.elevators.filter(e => e.status == 1).length
          var amountOffline2h = group.elevators.filter(e => e.status == 2).length
          var amountOffline24h = group.elevators.filter(e => e.status == 3).length
          var amountShutdown = group.elevators.filter(e => e.status == 4).length
          var amountError = group.elevators.filter(e => e.status == 5).length
          var amountFire = group.elevators.filter(e => e.status == 6).length
          var amountAlarm = group.elevators.filter(e => e.status == 7).length
          var amountEvac = group.elevators.filter(e => e.status == 8).length
          var amountPowerOff = group.elevators.filter(e => e.status == 9).length

          groupPie.node.innerHTML = pie(15,
            amountInspectionOnline, // 0
            amountMaintenanceOnline, // 1
            amountInspectionOffline2h, // 2
            amountMaintenanceOffline2h, // 3
            amountInspectionOffline24h, // 4
            amountMaintenanceOffline24h, // 5
            amountRepair, // 6
            amountUnknown, // 7
            amountNormal, // 8
            amountOffline2h, // 9
            amountOffline24h, // 10
            amountShutdown, // 11
            amountError, // 12
            amountFire, // 13
            amountAlarm, // 14
            amountEvac, // 15
            amountPowerOff // 16
          );
        }

        var s = this.statusForGroup(group);

        var groupStatusCountElement = this.$svg.get('#' + group.map_id + '-status-count');
        if(groupStatusCountElement != null) {
          groupStatusCountElement.node.textContent = this.elevatorsInGroupWithStatus(group, s).length; 
        }

        var groupStatusTextElement = this.$svg.get('#' + group.map_id + '-status-text');
        if(groupStatusTextElement != null) {
          groupStatusTextElement.node.textContent = this.statusTextForGroup(s);
        }

        var groupStatusColorElement = this.$svg.get('#' + group.map_id + '-status-color');
        if(groupStatusColorElement != null) {
          var c = this.statusClassForGroup(s);
          if (c != 'operational-online') {
            groupStatusColorElement.attr('style', '');
            groupStatusColorElement.attr('class', c);
          }
        }

        var btn = this.$svg.get('#' + group.map_id + '-stop-button');
        if (btn) {
          if(group.evac) {
            btn.node.childNodes[1].textContent = "START";
            btn.linkTo(groupLink + '/unevac');
          } else {
            btn.node.childNodes[1].textContent = "STOP";
            btn.linkTo(groupLink + '/evac');
          }
        }
      }
    },
    elevatorsInGroupWithStatus: function(group, status) {
      return group.elevators.filter(e => e.status == status);
    },
  },
}
</script>

<style>
#canvas {
  display: block;
  margin-right: auto;
  max-width: 1720px;
}
</style>



// WEBPACK FOOTER //
// src/GroupsMap.vue